import AdvisorModeSvg from '../../../assets/advisor-mode.svg?react';
import { IconProps } from '../../types/IconProps';

export function AdvisorMode({ size = 20, ...props }: IconProps) {
  return <AdvisorModeSvg data-testid="advisor-mode-icon" width={size} height={size} {...props} />;
}

export default AdvisorMode;
